import React from 'react';

import { isUUIDV4 } from '@aline/common';
import { routes } from '@aline/routes';
import { Typography } from '@mui/material';
import type { GridColumnHeaderParams } from '@mui/x-data-grid-premium';
import { useMatch } from 'react-router-dom';
import { AlineTooltip } from 'src/components/generic';
import { GenericPropertyIcon } from 'src/components/icons/GenericPropertyIcon';
import type { ReportGridRow } from 'src/components/reports/types';
import { Apollo } from 'src/gql/generated';
import { useGetExtractionQuestion } from 'src/hooks';
import { makeStyles } from 'tss-react/mui';

import { QuestionModeIcon } from './ReportCellPopover';

const useStyles = makeStyles()(theme => ({
  header: {
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(1),
    width: '100%',
  },
  headerName: {
    flex: 1,
    fontWeight: 600,
  },
}));

type ColumnHeaderProps = GridColumnHeaderParams<ReportGridRow, unknown>;

export function ColumnHeader(props: ColumnHeaderProps): JSX.Element {
  const { colDef } = props;
  const { classes } = useStyles();
  const isAIField = isUUIDV4(colDef.field);
  const reportRouteMatch = useMatch({ end: false, path: routes.ReportDetail });
  const { extractionQuestion } = useGetExtractionQuestion(colDef.field, { skip: !isAIField });

  return (
    <div className={classes.header}>
      {Boolean(reportRouteMatch) && (
        <ColumnHeaderIcon mode={isAIField ? extractionQuestion?.mode : undefined} />
      )}
      <Typography className={classes.headerName}>{colDef.headerName || 'Untitled'}</Typography>
    </div>
  );
}

export function ColumnHeaderIcon({ mode }: { mode?: Apollo.ExtractionQuestionMode }): JSX.Element {
  if (!mode) return <GenericPropertyIcon />;

  return (
    <AlineTooltip
      placement="top"
      title={mode === Apollo.ExtractionQuestionMode.Manual ? 'User Input' : 'AI Generated'}
    >
      <div>
        <QuestionModeIcon mode={mode} />
      </div>
    </AlineTooltip>
  );
}
